import { connect } from "react-redux";
import { RootState } from "../../../../reducers";
import { getPartnerDetails, getServiceRequestPayload } from "../../../../selector";
import { getCallIdFromCommonBenefits } from "../../../../selector";
import { OemDeflectionScreen as Component, OemDeflectionScreenProps } from "./OemDeflectionScreen.component";
import { getWarrantyDeflectionOemNumber } from "../../selectors";
import { submitCallOemPartialSaveRequest, submitDeclinePartialSaveRequest } from "../../actions";

const mapStateToProps = (state: RootState) =>
  ({
    oemNumber: getWarrantyDeflectionOemNumber(state),
    callId: getCallIdFromCommonBenefits(state),
    partnerCode: getPartnerDetails(state)?.partnerCode,
    serviceRequestPayload: getServiceRequestPayload(state),
  } as Pick<OemDeflectionScreenProps, "oemNumber" | "callId" | "partnerCode" | "serviceRequestPayload">);

const mapDispatchToProps = {
  onCallOem: submitCallOemPartialSaveRequest,
  onContinue: submitDeclinePartialSaveRequest,
} as Pick<OemDeflectionScreenProps, "onCallOem" | "onContinue">;

export const OemDeflectionScreen = connect(mapStateToProps, mapDispatchToProps)(Component);
